function handleIntersection(entries) {
    entries.map((entry) => {
        if (entry.isIntersecting && entry.target.classList.contains('video-container-not-loaded')){ 
            entry.target.classList.remove('video-container-not-loaded');
            const parentContainer = entry.target.closest('.mission-video-container');

            let videoSource = entry.target.querySelector('source');
            let videoText = parentContainer.querySelector('.video-text');

            videoSource.setAttribute('src', videoSource.getAttribute('data-src'));
            entry.target.load();
            entry.target.play();
            entry.target.addEventListener("timeupdate", (event) => {
             //   console.log(entry.target.currentTime);
                if(!videoText.classList.contains('load') && entry.target.currentTime > 5.7){
                    videoText.classList.add('load');
                }
            });
        }
    });
}
const observer = new IntersectionObserver(handleIntersection);

window.addEventListener("load", (event) => {
    document.querySelectorAll('.video-container-not-loaded').forEach((i) => {
        if (i) {
            observer.observe(i);
        }
    });
    
    document.querySelectorAll('.video-anchor-link').forEach(el => el.addEventListener('click', event => {
        const hashId = el.dataset.target;
        let hashContainer = document.getElementById('' + hashId + 'Container');
        if(hashContainer){
            window.scrollTo(0, hashContainer.offsetTop - document.getElementById('site-header').offsetHeight - 30);
        }
        return false;
    }));
    

});
